import { Lock, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function UpgradeGate({ title, description, benefits = [], onUpgraded }) {
  const requestUpgrade = async () => {
    try {
      const response = await api.post("/auth/request-upgrade");
      if (response.data.status === "already-pending") {
        toast.info("Your upgrade request is already pending. We'll be in touch.");
      } else {
        toast.success("Upgrade request submitted. We'll activate Pro on your workspace shortly.");
      }
      onUpgraded?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Could not submit upgrade request");
    }
  };

  return (
    <section className="upgrade-gate" data-testid="upgrade-gate">
      <div className="upgrade-icon"><Lock size={22} /></div>
      <h2>{title}</h2>
      <p>{description}</p>
      <ul>
        {benefits.map((benefit) => <li key={benefit}>· {benefit}</li>)}
      </ul>
      <div className="upgrade-price">
        <span>Pro plan</span>
        <strong>₹9,999<em>/month</em></strong>
      </div>
      <button className="primary-button" data-testid="upgrade-to-pro-button" onClick={requestUpgrade}>
        Request Pro upgrade <ArrowUpRight size={15} />
      </button>
      <small>An admin will activate Pro on your workspace after billing is confirmed.</small>
    </section>
  );
}
